import { useState } from 'react';
import { List, Checkbox, Message, Button } from 'semantic-ui-react';
import Swal from 'sweetalert2';
import { saveEntry as saveEntryAPI } from '../services/trainingViewService';

const UsersAssignTab = ({
  users,
  loading,
  entry,
  selectedUsers: initialSelectedUsers,
  selectAll: initialSelectAll,
  onEntryUpdated,
  context,
}) => {
  const [selectedUsers, setSelectedUsers] = useState(initialSelectedUsers || []);
  const [selectAll, setSelectAll] = useState(initialSelectAll || false);
  const [saving, setSaving] = useState(false);

  // Handle user selection for assignment
  const handleUserToggle = (userId) => {
    setSelectedUsers((prev) => {
      if (prev.includes(userId)) {
        return prev.filter((id) => id !== userId && id !== 'all');
      } else {
        return [...prev.filter((id) => id !== 'all'), userId];
      }
    });
    setSelectAll(false);
  };

  // Handle "Select All" toggle
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedUsers([]);
      setSelectAll(false);
    } else {
      setSelectedUsers(['all']);
      setSelectAll(true);
    }
  };

  // Save assigned users
  const handleSaveAssignments = async () => {
    setSaving(true);
    try {
      const assignedTo = selectAll ? ['all'] : selectedUsers;
      const entryData = {
        id: entry.id,
        title: entry.title,
        type: entry.type,
        content: entry.content,
        link: entry.link,
        assigned_to: assignedTo,
      };

      const response = await saveEntryAPI(entryData);

      if (response.bulletin) {
        Swal.fire({
          icon: 'success',
          title: 'Asignaciones actualizadas',
          text: 'Los usuarios asignados han sido actualizados correctamente.',
          timer: 2000,
          showConfirmButton: false,
        });

        // Refresh entries in context
        if (context?.fetchBulletins) {
          context.fetchBulletins();
        }

        // Update selected entry in context
        if (context?.setSelectedEntry && response.bulletin) {
          context.setSelectedEntry(response.bulletin);
        }

        if (onEntryUpdated) {
          onEntryUpdated(response.bulletin);
        }
      }
    } catch (error) {
      console.error('Error saving assignments:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text:
          error.response?.data?.message ||
          error.message ||
          'No se pudieron guardar las asignaciones. Por favor, intenta de nuevo.',
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <div style={{ marginBottom: '1rem' }}>
        <Message info>
          <Message.Header>Asignar contenido a usuarios</Message.Header>
          <p>
            Selecciona los usuarios que podrán ver este contenido. Si seleccionas "Todos los
            usuarios", todos los usuarios con status staff podrán verlo.
          </p>
        </Message>
      </div>

      <div
        style={{
          marginBottom: '1.5rem',
          padding: '1rem',
          background: '#f8f9fa',
          borderRadius: '4px',
        }}
      >
        <Checkbox
          checked={selectAll}
          onChange={handleSelectAll}
          label="Todos los usuarios (staff)"
          style={{ fontSize: '16px', fontWeight: 600 }}
        />
      </div>

      {!selectAll && (
        <div>
          <h4 style={{ marginBottom: '1rem' }}>Seleccionar usuarios específicos:</h4>
          {loading ? (
            <p>Cargando usuarios...</p>
          ) : users.length > 0 ? (
            <List divided relaxed>
              {users.map((user) => {
                const isSelected = selectedUsers.includes(user.id);
                return (
                  <List.Item key={user.id}>
                    <List.Content>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '1rem',
                        }}
                      >
                        <Checkbox
                          checked={isSelected}
                          onChange={() => handleUserToggle(user.id)}
                          disabled={selectAll}
                        />
                        <div
                          style={{
                            flex: 1,
                            cursor: selectAll ? 'default' : 'pointer',
                          }}
                          onClick={() => !selectAll && handleUserToggle(user.id)}
                        >
                          <List.Header>{user.name}</List.Header>
                          <List.Description>{user.email}</List.Description>
                        </div>
                      </div>
                    </List.Content>
                  </List.Item>
                );
              })}
            </List>
          ) : (
            <p style={{ color: '#999', fontStyle: 'italic' }}>
              No hay usuarios con status staff disponibles.
            </p>
          )}
        </div>
      )}
      {selectAll && (
        <Message success>
          <Message.Header>Todos los usuarios seleccionados</Message.Header>
          <p>Todos los usuarios con status staff podrán ver este contenido.</p>
        </Message>
      )}

      <div style={{ marginTop: '2rem', textAlign: 'right' }}>
        <Button primary onClick={handleSaveAssignments} loading={saving} disabled={saving}>
          Guardar Asignaciones
        </Button>
      </div>
    </>
  );
};

export default UsersAssignTab;
